import { createStyles } from '../../../../styles/helpers'

const useStyles = createStyles({
  checkBoxContainer: {}
})

export default useStyles
